<ng-content></ng-content>

<div class="menu-container">
  <div class="sidebar-menu">
    <div
      *ngFor="let item of items"
      class="tree-item"
      [class.active-item]="item.featureName  === activeFeature"
      (click)="onItemClick2(item)"
    >
      <img
        [src]="item.featureName  === activeFeature ? item.selectedIcon : item.icon"
        class="item-icon"
      />
      <span class="item-text">{{ item.text }}</span>
    </div>
  </div>
</div>